@if (visibility) {
  <div class="filter-popover">
    <div class="wrapper">
      <form [formGroup]="prepareFilter">
        @if (!addFilter) {
          <mat-card appearance="outlined" class="filter-mat-card">
            <div class="filter-panel__head">
              <h2 class="filter-label">Filtros</h2>
              <button type="button" class="add-filter-button" (click)="addFilter = true" mat-button>
                <mat-icon aria-hidden="true">bookmark_border</mat-icon> Filtros guardados
              </button>
            </div>
            <mat-card-content>
              <mat-accordion class="custom-accordion">
                <mat-expansion-panel class="custom-expansion-panel" hideToggle="true" (opened)="panelOpenState = 'category'"
                  (closed)="checkPanelState('category')">
                  <mat-expansion-panel-header>
                    <mat-icon>{{ getButton("category") }}</mat-icon>
                    <mat-panel-title> Tipo de tarea </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Seleccionar tipo de tareas</mat-label>
                    <mat-select class="select" formControlName="groupType" multiple>
                      @for (tg of taskGroups; track tg) {
                        <mat-option [value]="tg.id.toString()"
                          (click)="getJobs(tg.id); clearSelectedfilterId()">
                          {{ tg.description }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </mat-expansion-panel>
                <mat-expansion-panel class="custom-expansion-panel" hideToggle="true"
                  (opened)="panelOpenState = 'subCategory'" (closed)="checkPanelState('subCategory')">
                  <mat-expansion-panel-header>
                    <mat-icon>{{ getButton("subCategory") }}</mat-icon>
                    <mat-panel-title> Subcategoría </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Seleccionar tareas</mat-label>
                    <mat-select class="select" formControlName="taskType" multiple>
                      @for (group of grouping; track group) {
                        <mat-optgroup [label]="group.groupName">
                          @for (j of group.jobs; track j) {
                            <mat-option [value]="j.id.toString()"
                              (click)="clearSelectedfilterId()">
                              {{ j.description }}
                            </mat-option>
                          }
                        </mat-optgroup>
                      }
                    </mat-select>
                  </mat-form-field>
                </mat-expansion-panel>
                <mat-expansion-panel class="custom-expansion-panel" hideToggle="true"
                  (opened)="panelOpenState = 'clientName'" (closed)="checkPanelState('clientName')">
                  <mat-expansion-panel-header>
                    <mat-icon>{{ getButton("clientName") }}</mat-icon>
                    <mat-panel-title> Nombre de cliente </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline">
                    <mat-chip-grid #chipList formControlName="clientName">
                      <input placeholder="Clientes" [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                        (matChipInputTokenEnd)="add($event)" />
                      </mat-chip-grid>
                    </mat-form-field>
                    <mat-chip-listbox #chipList>
                      @for (client of clients; track client) {
                        <mat-chip-option class="cardinal-colors" (click)="remove(client)">
                          <label class="truncate-text">{{ client }}</label>
                          <mat-icon title="Quitar filtro" class="mat-chip-remove">cancel</mat-icon>
                        </mat-chip-option>
                      }
                    </mat-chip-listbox>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true"
                    (opened)="panelOpenState = 'contractor'" (closed)="checkPanelState('contractor')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("contractor") }}</mat-icon>
                      <mat-panel-title> Prestador </mat-panel-title>
                    </mat-expansion-panel-header>
                    <multiselect-autocomplete #contractorComponent placeholder="Prestadores" key="contractors"
                      [data]="contractors" (result)="contractorSelectChange($event)">
                    </multiselect-autocomplete>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true"
                    (opened)="panelOpenState = 'ignoredContractor'" (closed)="checkPanelState('ignoredContractor')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("ignoredContractor") }}</mat-icon>
                      <mat-panel-title> Ignorar prestador </mat-panel-title>
                    </mat-expansion-panel-header>
                    <multiselect-autocomplete #ignoredContractorComponent placeholder="Prestadores a ignorar"
                      key="ignoredContractors" [data]="ignoredContractorOptions"
                      (result)="ignoredContractorSelectChange($event)">
                    </multiselect-autocomplete>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true" (opened)="panelOpenState = 'date'"
                    (closed)="checkPanelState('date')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("date") }}</mat-icon>
                      <mat-panel-title> Fecha de pedido </mat-panel-title>
                    </mat-expansion-panel-header>
                    <section class="pt-3 pb-1">
                      <app-dates-filter [visibility]="isVisible" [isPopover]="false" (setPickerEmit)="setPicker()"
                        (sendDates)="setDates($event)" [showApplyBtn]="false" [autoApply]="true" [showSidePanel]="false"
                  [defautFromDate]="
                    prepareFilter.controls.creationDateFrom.value
                  " [defautToDate]="
                    this.prepareFilter.controls.creationDateTo.value
                  "></app-dates-filter>
                    </section>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true" (opened)="panelOpenState = 'status'"
                    (closed)="checkPanelState('status')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("status") }}</mat-icon>
                      <mat-panel-title> Estado </mat-panel-title>
                    </mat-expansion-panel-header>
                    <section class="mt-1" style="text-align: left">
                      @for (item of taskStatuses; track item; let i = $index) {
                        <p>
                          <mat-checkbox (change)="selectStatus(item); clearSelectedfilterId()" [checked]="item.selected">
                            <span class="dot" [style.background-color]="item.eventColor.primary"></span>
                            {{ item.name }}
                          </mat-checkbox>
                        </p>
                      }
                    </section>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true"
                    (opened)="panelOpenState = 'pointOfSales'" (closed)="checkPanelState('pointOfSales')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("pointOfSales") }}</mat-icon>
                      <mat-panel-title> Puntos de venta </mat-panel-title>
                    </mat-expansion-panel-header>
                    <multiselect-autocomplete #sealesPointsComponent placeholder="Puntos de venta" key="pointOfSales"
                      [data]="sealesPoints" (result)="sealesPointsSelectChange($event)">
                    </multiselect-autocomplete>
                  </mat-expansion-panel>
                  <!-- Without read:tasks (e.g. the seller role) the API only returns the user's own tasks: nothing to filter by creator. -->
                  @if (usrSvc.hasPermission('read:tasks')) {
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true" (opened)="panelOpenState = 'creator'"
                    (closed)="checkPanelState('creator')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("creator") }}</mat-icon>
                      <mat-panel-title> Creador </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-form-field class="w-100 creator-field" appearance="outline">
                      <mat-select multiple [compareWith]="compareObjects" formControlName="owner">
                        @for (creator of creatorNames; track creator; let i = $index) {
                          <mat-option [value]="creator"
                            (click)="selectCreator(creator); clearSelectedfilterId()">
                            {{ creatorNames[i].name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </mat-expansion-panel>
                  }
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true"
                    (opened)="panelOpenState = 'paidLabor'" (closed)="checkPanelState('paidLabor')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("paidLabor") }}</mat-icon>
                      <mat-panel-title> Mano de obra </mat-panel-title>
                    </mat-expansion-panel-header>
                    <section class="mt-1" style="text-align: left">
                      <mat-radio-group class="radio-group" (change)="clearSelectedfilterId()" formControlName="isPaidLabor">
                        <mat-radio-button [value]="null">Todas</mat-radio-button>
                        <mat-radio-button [value]="true">Paga</mat-radio-button>
                        <mat-radio-button [value]="false">No paga</mat-radio-button>
                      </mat-radio-group>
                    </section>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="tags-filter custom-expansion-panel" hideToggle="true"
                    (opened)="panelOpenState = 'tags'" (closed)="checkPanelState('tags')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("tags") }}</mat-icon>
                      <mat-panel-title> Etiquetas </mat-panel-title>
                    </mat-expansion-panel-header>
                    <section class="mt-1" style="text-align: left">
                      @for (item of tags; track item; let i = $index) {
                        <mat-checkbox
                          (change)="selectTag(item,$event); clearSelectedfilterId()" [checked]="checkSelectedTag(item.id)"
                          [style.background-color]="item.color">
                          <div class="tag-preview tag-list-item" [style.background-color]="item.color"
                            [ngStyle]="{ '--after-background-color': item.color }">
                            <label class="tag-label">{{ item.name }}</label>
                          </div>
                        </mat-checkbox>
                      }
                    </section>
                  </mat-expansion-panel>
                  <mat-expansion-panel class="custom-expansion-panel" hideToggle="true" (opened)="panelOpenState = 'product'"
                    (closed)="checkPanelState('product')">
                    <mat-expansion-panel-header>
                      <mat-icon>{{ getButton("product") }}</mat-icon>
                      <mat-panel-title> Producto </mat-panel-title>
                    </mat-expansion-panel-header>
                    <multiselect-autocomplete #productComponent placeholder="Productos" key="products" [data]="products"
                      (result)="productsSelectChange($event)">
                    </multiselect-autocomplete>
                  </mat-expansion-panel>
                </mat-accordion>
                <div class="text-switch row mb-2" [formGroup]="canceledTasksForm">
                  <div class="col d-flex justify-content-between align-items-center">
                    <span>Mostrar tareas canceladas</span>
                    <mat-slide-toggle (change)="emitToggleChange($event)" formControlName="canceledTasks"></mat-slide-toggle>
                  </div>
                </div>
                @if (usrSvc.hasPermission('view:postponedTaskFilter')) {
                  <div class="text-switch row mb-2" [formGroup]="postponedForm"
                    >
                    <div class="col d-flex justify-content-between align-items-center">
                      <span>Mostrar tareas pospuestas</span>
                      <mat-slide-toggle formControlName="postponedTasks"
                      (change)="includePostponedToggleChange($event)"></mat-slide-toggle>
                    </div>
                  </div>
                }
                @if (usrSvc.hasPermission('view:pendingContactFilter')) {
                  <div class="text-switch row mb-2" [formGroup]="onlyContactForm"
                    >
                    <div class="col d-flex justify-content-between align-items-center">
                      <span>Solo contacto pendiente</span>
                      <mat-slide-toggle formControlName="onlycontact"
                      (change)="emitPendingContactToggleChange($event)"></mat-slide-toggle>
                    </div>
                  </div>
                }
                @if (usrSvc.hasPermission('view:pendingContactFilter')) {
                  <div class="text-switch row mb-2" [formGroup]="onlyBudgetedForm"
                    >
                    <div class="col d-flex justify-content-between align-items-center">
                      <span>Mostrar tareas presupuestadas</span>
                      <mat-slide-toggle formControlName="onlyBudgeted"
                      (change)="includeBudgetedChange($event)"></mat-slide-toggle>
                    </div>
                  </div>
                }
                <div class="filter-panel__actions">
                  <button type="button" class="clear-button" title="Quitar filtros seleccionados"
                    (click)="CleanUpFilter()" mat-stroked-button>
                    Limpiar filtros
                  </button>
                  <button type="button" class="apply-button" title="Aplicar filtros seleccionados"
                    (click)="filterSchedule()" mat-flat-button>
                    Aplicar filtros
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          }
          @if (addFilter) {
            <mat-card appearance="outlined" class="filter-mat-card">
              <div class="filter-panel__head">
                <h2 class="filter-label">Filtros guardados</h2>
              </div>
              <mat-card-content>
                <div class="content-filters-list">
                  <form [formGroup]="selectedfilterId">
                    <mat-radio-group class="radio-group" formControlName="id">
                      @for (filter of scheduleUserfilters; track filter) {
                        <div class="row w-100">
                          <div class="col-10">
                            <mat-radio-button (click)="selectedFilter(filter.id)" [value]="filter.id" class="float-left">
                              {{ filter.description }}
                            </mat-radio-button>
                          </div>
                          <div class="col-2 pl-0 pr-0">
                            <img mat-mdc-raised-button class="float-right mt-1 cursor-pointer"
                              src="../../../../assets/icons/common/delete.svg" alt="Eliminar filtro"
                              title="Eliminar filtro {{ filter.description }}" (click)="removeScheduleFilters(filter.id)" />
                            </div>
                          </div>
                        }
                      </mat-radio-group>
                    </form>
                    @if (saveFilter) {
                      <div class="row mt-4">
                        <form [formGroup]="newFilter">
                          <mat-form-field appearance="outline">
                            <input class="w-100" matInput placeholder="Nombra tu filtro" formControlName="description" required />
                          </mat-form-field>
                        </form>
                      </div>
                    }
                    @if (saveFilter) {
                      <div class="row">
                        <div class="col-6">
                          <button type="button" class="cancel-button-lite mt-0" (click)="saveFilter = false"
                            mat-stroked-button>
                            Cancelar
                          </button>
                        </div>
                        <div class="col-6">
                          <button type="button" class="save-button mt-0"
                            (click)="addFilter = true; addSchedulefilters()" mat-flat-button>
                            Guardar
                          </button>
                        </div>
                      </div>
                    }
                    @if (!saveFilter) {
                      <div class="row mt-4">
                        <div class="col-6">
                          <button type="button" class="w-100" (click)="saveFilter = true" mat-stroked-button
                            [disabled]="!hasFilterToSave() && isNewFilter()">
                            + Agregar filtro
                          </button>
                        </div>
                      </div>
                    }
                    @if (!saveFilter) {
                      <div class="row">
                        <Span class="clear-filter-button">
                        Guarde su selección personalizada de filtros.
                      </Span>
                    </div>
                  }
                  <div class="row mb-2 mt-3">
                    <div class="clear-filter-button-content">
                      <button type="button" class="back-to-filters" title="Volver a opciones de filtro" (click)="initFilters()" mat-button>
                        <mat-icon aria-hidden="true">arrow_back</mat-icon> Volver a filtros
                      </button>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          }
        </form>
      </div>
    </div>
  }